import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers } from "@reco-m/core";
import { app, changeDocument, getParkCode } from "@reco-w/core-ui";

import { cmsService } from "@reco-w/common-service";

import { Namespaces } from "./common";

export namespace cmsCommonModel {
    export const namespace = Namespaces.cmsCommon;

    export const state: any = freeze({}, !0);

    export type StateType = typeof state;
    export const reducers: ReducersMapObject = {
        ...CoreReducers,
        *initState() {
            return state;
        },
    };
    export const effects: EffectsMapObject = {
        ...CoreEffects,
        /**
         * 获取head标签内的数据
         */
        *getHeadJson({ message, title, params, location }, { call }) {
            try {
                const json = yield call(cmsService.getHeadJson);

                let local = location;
                if (location) {
                    local = client["isMultyPark"] ? getParkCode() + location : location;
                }
                if (json) {
                    changeDocument(json, title, params, local);
                }
            } catch (e) {
                yield call(message?.error, "getHeadJson：" + e.errmsg);
            }
        },
    };
}

app.model(cmsCommonModel);
